
export class CasesForm {
    userId = "";
    id = "";
    sugarCaseKey = "";
    caseNumber = "";    
    dealerId:{
              id:string,
              superDealerCode:string,
              name:string,
              globalCode:string,
              localCode:string,
              regionCode:string,
              countryCode:string
             }; 
    assignedTo:{
                id:number,
                userName:string,
                firstName:string,
                lastName:string};
    vehicleType: {
                  id: number,
                  make: string,
                  model:  string
                 };            
    individualId: {
              id: number,
              firstName: string,
              companyName: string,
              lastName: string,
              phone: string,
              phoneTimeToCall: string,
              mobile: string,
              mobileTimeToCall:string,
              email: string,
             addressId:{
                           id:string,
                           address1:string,
                           address2:string,
                           city:string,
                           postalCode:string,
                           stateId:{
                                    id:string,
                                    stateCode:string,
                                    name:string
                                    },
                            countryId:{
                                      id: string,
                                      code:string,
                                      name:string
                                      }
                        } 
              optedIn:any,
              deleted:any,
              dateSynced: any,  
              userId:string,
              assignedTo:{
                         id:number,
                         userName:string,
                         firstName:string,
                         lastName:string
                         };  
              dealerId:{
                        id:any,
                        superDealerCode:string,
                        name:string,
                        globalCode:string,
                        localCode:string,
                        regionCode:string,
                        countryCode:string
                       };              
             dateEntered: Date,
             createdBy: {id: number,userName: string,firstName: string,lastName: string,leadNotification: any,caseNotification: any,notificationTime: any};
             dateModified: Date
              modifiedBy:{id: number,userName: string,firstName: string,lastName: string,leadNotification: any,caseNotification: any,notificationTime: any};       
            vehicles: [
                        {
                          id:number
                          sugarVKey: string,
                          individualId: string,
                          vin: string,
                          purchaseDate: Date,
                          cycle: {},
                          salesType: {},
                          vehicleType: {
                            id: number,
                            make: string,
                            model: string
                          },
                          year: string,
                          dateEntered: Date,
                          createdBy: {id: number,userName: string,firstName: string,lastName: string,leadNotification: any,caseNotification: any,notificationTime: any};
                          dateModified: Date,
                          modifiedBy:{id: number,userName: string,firstName: string,lastName: string,leadNotification: any,caseNotification: any,notificationTime: any};
                          deleted:any,
                          dateSynced: any,
                        }
                      ]
      };                
    typeId: {id:number,code:string,description:string,active:any};
    statusId: {id:number,code:string,description:string,active:any};
    sourceId:{id:any,code:string,description:string,active:any};
    priorityId:{id:number,code:string,description:string,active:any};
    categoryId:{id:number,code:string,description:string,active:any};
    subCategory1Id:{id:any,code:string,description:string,active:any};
    subCategory2Id:{id:any,code:string,description:string,active:any};
    customerNote: string;
    firstContactResolution: string;
    dateCreated:Date;
    createdBy: {id: number,userName: string,firstName: string,lastName: string,leadNotification: any,caseNotification: any,notificationTime: any};
    dateClosed:Date;
    closedBy: {id: number,userName: string,firstName: string,lastName: string,leadNotification: any,caseNotification: any,notificationTime: any};
    dateModified:Date;
    modifiedBy: {id: number,userName: string,firstName: string,lastName: string,leadNotification: any,caseNotification: any,notificationTime: any};
    deleted: any;
    dateSynced: any;
    activity: [{}];
    
    constructor(userId:string,
                id:string,
                sugarCaseKey :string,
                caseNumber :string,
                assignedTo:any,
                dealerId:any,
                vehicleType :any,
                individualId:any,
                typeId:any,
                statusId: any,  
                sourceId:any, 
                priorityId:any,
                categoryId:any,
                subCategory1Id:any,
                subCategory2Id:any,
                customerNote: string,
                firstContactResolution: string,
                dateCreated:Date,
                createdBy:any,
                dateClosed:Date,
                closedBy:any,
                dateModified:Date,
                modifiedBy: any,
                deleted: any,
                dateSynced: any,
                activity: any
                
    ) {
    this.userId =userId;
    this.id = id;
    this.sugarCaseKey=sugarCaseKey;
    this.caseNumber=caseNumber;
    this.assignedTo=assignedTo;
    this.dealerId=dealerId;
    this.vehicleType=vehicleType;
    this.individualId = individualId;
    this.typeId=typeId;            
    this.statusId=statusId;
    this.sourceId= sourceId;
    this.priorityId=priorityId;
    this.categoryId=categoryId;
    this.subCategory1Id=subCategory1Id;     
    this.subCategory2Id=subCategory2Id;     
    this.customerNote=customerNote;
    this.firstContactResolution= firstContactResolution;
    this.dateCreated=dateCreated;
    this.createdBy= createdBy;    
    this.dateClosed=dateClosed;
    this.closedBy=closedBy;
    this.dateModified=dateModified;
    this.modifiedBy= modifiedBy;
    this.deleted= deleted;
    this.dateSynced= dateSynced;
    this.activity=activity;
    
  
        
    }
}






// WEBPACK FOOTER //
// ./src/app/modules/cases/models/data-model.ts